import { DatatableFocusAreaTemplateColumn } from "@/domain/focus-area/components/datatable-focus-area-column/datatable-focus-area-template-column";
import { Workspace } from "@/domain/workspace/models/workspace-model";
import i18n from "@/lib/i18n";

import { ClimateAction } from "../../../models/climate-action";

export const COLUMN_ID_CLIMATE_ACTION_FOCUS_AREA = "focus_area";
export const COLUMN_ORDER_VALUE_CLIMATE_ACTION_FOCUS_AREA = 201;

interface ClimateActionFocusAreaColumnProps {
  workspace: Workspace;
  columnId?: string;
  orderValue?: number;
  displayValue?: string;
  editable?: boolean;
}

export const ClimateActionFocusAreaColumn = ({
  workspace,
  columnId = COLUMN_ID_CLIMATE_ACTION_FOCUS_AREA,
  orderValue = COLUMN_ORDER_VALUE_CLIMATE_ACTION_FOCUS_AREA,
  displayValue = i18n.t("columns.focusArea", { ns: "climate-action" }),
  editable = false,
}: ClimateActionFocusAreaColumnProps) => {
  return DatatableFocusAreaTemplateColumn<ClimateAction>({
    workspace,
    columnId,
    orderValue,
    displayValue,
    editable,
    focusAreaInstanceFromRow: (row) => row.focusAreaInstance ?? null,
    ownerIdFromRow: (row) => row.id,
  });
};
